@if (options.control) {
<div class="relative">
  <div class="eye__icon reverse__password-icon" inlineSVG="auth/eye.svg" (click)="eye = !eye"
    [ngClass]="{ show_pass: eye }"></div>
  <input [type]="eye ? 'text' : 'password'" [id]="id" class="global-input peer"
    [placeholder]="options.label | translate" [formControl]="options.control" />

  <label [for]="id" class="floating-label" [translate]="options.label" [ngClass]="{'required':isRequired }">
  </label>
</div>
} @else {
Form Control Is Not Defined
}

@if (options.isShowErrors) {
<span class="text-red-500 block" *ngIf="options.control?.errors?.['required']"
  translate="This field is required"></span>
<span class="text-red-500 block" *ngIf="options.control?.errors?.['confirmPassword']"
  translate="Password does not match">
</span>

<span class="text-red-500 block" *ngIf="options.control?.errors?.['password']" translate="Must contain uppercase and lowercase letters, numbers, and special
   characters, and be at least 8 characters long"></span>
}